module.exports = __webpack_public_path__ + "static/media/na.f770c272.svg";